import LplLogoWhiteIcon from '../assests/images/icons/lpl-logo-white-bg.png'
import Dashboard from '../assests/images/icons/home-icon-side.png'
import AddIconFilters from '../assests/svg/add-icon-filters.svg'
import LocalityIcon from '../assests/svg/LocalityIcon.png'
import CitySideIcon from '../assests/svg/city-side-icon.png'
import StateSideIcon from '../assests/svg/setting-side-icon.svg'
import SelectCountry from '../assests/svg/select-country.png'
import MasterIcon from '../assests/svg/mastersKey.png'
import SubscriptionIcon from '../assests/svg/subscription-icon.png'
import UserMangIcon from '../assests/svg/user-manage-icon.png'
import RolesIcon from '../assests/svg/roles=icon.svg'
import BMBLogo from '../assests/images/icons/Book-my-beauty-logo.png'
import BMBSimpleLogo from '../assests/images/icons/Book my beauty logo.png'
import HomeIcon from '../assests/images/icons/HomeIcon.png'
import SettingIcon from '../assests/images/icons/SettingIcon.png'
import Customers from '../assests/images/icons/UsersManage.png'
import CategoriesIcon from '../assests/images/icons/CategoriesIcon.png'
import SalonIcon from '../assests/images/icons/SalonIcon.png'
import UserManagementIcon from '../assests/images/icons/UserManage.png'
import UserIcon from '../assests/images/icons/UserIcon.png'
import EditIcon from '../assests/images/icons/EditIcon.png'
import DeleteIcon from '../assests/images/icons/DeleteIcon.png'
import ViewIcon from '../assests/images/icons/ViewIcon.png'
import AdminIcon from '../assests/images/icons/AdminIcon.png'
import AppoinmentIcon from '../assests/images/icons/AppoinmentIcon.png'
import BMBLogoSmall from '../assests/images/icons/BMB Logo SM.png'
import LoginImage from '../assests/images/icons/LoginPageImage.png'
import BlockIcon from '../assests/images/icons/block.png'
import BanIcon from '../assests/images/icons/ban.png'
import Male from '../assests/svg/male.png'
import Female from '../assests/svg/female.png'
import PhoneIcon from '../assests/images/icons/phone-icon.png'
import LocationIcon from '../assests/images/icons/location-icon.png'
import UserProfile from '../assests/images/icons/user-icon.png'
import GenderIcon from '../assests/images/icons/gender-icon.png'
import TestimonialIcon from '../assests/images/icons/testimonial-icon.svg'
import ImageIcon from '../assests/images/icons/image-icon.svg'
import Makeup from '../assests/images/thumbnails/makeup.webp';
import Hair from '../assests/images/thumbnails/hair.webp';
import SkinCare from '../assests/images/thumbnails/skincare.webp';
import VideoIcon from '../assests/images/icons/videoIcon.png';
import imageNotFound from '../assests/images/icons/34-img-not-found.jpg';
import TaxiLogo from '../assests/images/icons/taxi-booking-logo.png';
import LoginTaxiLogo from '../assests/images/icons/login-taxi-booking-logo.png';
import BookingManage from '../assests/images/icons/BookingManage.png';
import Booking from '../assests/images/icons/Booking.png';
import BookingStatus from '../assests/images/icons/BookingStatus.png';
import OtherMaster from '../assests/images/icons/OtherMaster.png';
import privacy from '../assests/images/icons/privacy.png';
import termscondition from '../assests/images/icons/termscondition.png';
import panaltystructure from '../assests/images/icons/termscondition.png';
import logout from '../assests/images/icons/logout.png';


const IMAGES = {
  LoginImage,
  TaxiLogo,
  LoginTaxiLogo,
  BookingManage,
  Booking,
  BookingStatus,
  OtherMaster,
  privacy,
  termscondition,
  panaltystructure,
  logout,
  BMBSimpleLogo,
  BMBLogoSmall,
  AppoinmentIcon,
  UserManagementIcon,
  UserIcon,
  AdminIcon,
  DeleteIcon,
  SettingIcon,
  ViewIcon,
  SalonIcon,
  Customers,
  CategoriesIcon,
  HomeIcon,
  BMBLogo,
  LplLogoWhiteIcon,
  Dashboard,
  EditIcon,
  AddIconFilters,
  LocalityIcon,
  CitySideIcon,
  StateSideIcon,
  SelectCountry,
  MasterIcon,
  SubscriptionIcon,
  UserMangIcon,
  RolesIcon,
  BlockIcon,
  BanIcon,
  Male,
  Female,
  LocationIcon,
  PhoneIcon,
  UserProfile,
  GenderIcon,
  TestimonialIcon,
  ImageIcon,
  Makeup,
  Hair,
  SkinCare,
  VideoIcon,
  imageNotFound
}

export default IMAGES;